export const validateBirthdate = (value: string) => {
	const today = new Date();
	const birthDate = new Date(value);

	const differenceInYears = (today.getTime() - birthDate.getTime()) / (1000 * 3600 * 24 * 365);

	if (birthDate.toString() === 'Invalid Date' || birthDate.getFullYear() < 1900) {
		return 'Je hebt je geboortedatum onjuist ingevuld.';
	}

	if (birthDate > today) {
		return 'Je geboortedatum moet een dag uit het verleden zijn.';
	}

	if (differenceInYears < 18) {
		return 'Je moet minimaal 18 jaar oud zijn.';
	}
	return true;
};
